"use client";
import React from 'react';
import OngoingOrders from './OngoingOrders';
import { useEffect } from "react";

const ProfileOrders = () => {
  useEffect(() => {
      window.scrollTo(0, 0);  // ⬅️ Scroll to top when this page mounts
    }, []);
  return <OngoingOrders />;
};

export default ProfileOrders;
